exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-select[data-v-b2d10e08]{line-height:32px;height:50px;border-radius:1px}", ""]);

// exports
